export const style = {
  action: {
    sx: (isDisabled: boolean) => {
      return {
        '&': {
          backgroundColor: isDisabled ? 'rgba(48, 37, 133, 0.34)' : 'primary.main',
          color: '#fff',
          pointerEvents: isDisabled ? 'none' : 'all',
        },
      };
    },
  },
  dialog: {
    maxWidth: 'md',
    sx: {
      width: '100%',
      '.MuiDialogTitle-root+.css-y9xvel-MuiDialogContent-root': {
        pt: 4,
      },
    },
    dialogActions: {
      sx: {
        mx: 1,
      },
    },
    dialogContent: {
      sx: {
        mt: 2,
        minHeight: 250,
        minWidth: 600,
        p: 2,
      },
    },
  },
} as const;
